import { themeToCss } from "@/modules/theme/cssBuilder.ts";
import { themeAtom } from "@/modules/theme/theme.store.ts";
import { buildThemeVars } from "@/modules/theme/themeBuilder.ts";
import { atom } from "jotai/vanilla";

export const themeCssAtom = atom((get) => themeToCss(buildThemeVars(get(themeAtom).makeTheme)));
